// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "icons-18ehP";
var _3 = "icon-3Qy1P";
export { _1 as "__esModule", _2 as "icons", _3 as "icon" }
export default { "__esModule": _1, "icons": _2, "icon": _3 }
